import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { Context } from '../shared'
import {
  AuthenticationAttemptRecordType,
  AuthenticationAttemptRecord
} from '../types/authentication-attempt-record'
import {
  atoAttackQueryArgs,
  ATOAttackQueryArgs
} from '../types/ato-attack-query-args'

export const authenticationAttemptRecord: GraphQLFieldConfig<
  any,
  Context,
  ATOAttackQueryArgs
> = {
  description: 'ATO records for this organization',
  type: new GraphQLNonNull(AuthenticationAttemptRecordType),
  args: atoAttackQueryArgs,
  async resolve(): Promise<Partial<AuthenticationAttemptRecord>> {
    return {
      requests: 0
    }
  }
}
